import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Container,
  CssBaseline,
  ThemeProvider,
  Typography,
  useMediaQuery,
} from "@mui/material";
import theme from "../../../config/theme";
import { useState } from "react";
import { ExpandMore } from "@mui/icons-material";
import { StyledButton } from "../../../components/common/Button";

const faqData = [
  {
    panel: "panel1",
    question:
      "What is the difference between the Free, Academy, and Institute plans?",
    answer:
      "The Free plan is perfect for individual educators with basic student management and attendance tracking. The Academy plan ($20-25/month) adds advanced features like parent communication, financial management, and analytics. The Institute plan ($60-75/month) includes enterprise features like AI-powered insights, unlimited users, custom integrations, and dedicated support.",
  },
  {
    panel: "panel2",
    question:
      "Can I upgrade or downgrade my plan at any time?",
    answer:
      "Yes, you can upgrade your plan at any time to access more features immediately. Downgrades take effect at the next billing cycle. All your data is preserved during plan changes, ensuring a seamless transition between tiers.",
  },
  {
    panel: "panel3",
    question:
      "Is there a free trial available for paid plans?",
    answer:
      "Yes, we offer a 14-day free trial for both Academy and Institute plans. No credit card required to start. You can explore all features and decide which plan works best for your institution before committing to a subscription.",
  },
  {
    panel: "panel4",
    question:
      "What kind of support do you provide?",
    answer:
      "All plans include email support. Academy plan users get phone support during business hours, while Institute plan users receive 24/7 support with a dedicated account manager. We also provide training sessions to help your team get the most out of the platform.",
  },
  {
    panel: "panel5",
    question:
      "How secure is my institution's data?",
    answer:
      "We use enterprise-grade security with 256-bit SSL encryption, regular security audits, and comply with GDPR regulations. All data is backed up daily with 99.9% uptime guarantee. Institute plan users get additional security features like SSO integration and audit logs.",
  },
  {
    panel: "panel6",
    question:
      "Can I integrate Youstad with my existing systems?",
    answer:
      "Yes, our platform offers various integration options. Academy plan includes basic LMS integration, while Institute plan supports advanced integrations with accounting software, third-party apps, and custom API access for seamless workflow management.",
  },
];

const FAQs = () => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box>
        <Box sx={{ backgroundColor: "#EEF6FF" }}>
          <Container>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  marginTop: ["3.75rem", "6.875rem"],
                  fontSize: ["1.375rem", "3rem"],
                  fontWeight: 700,
                  textAlign: "center",
                  color: "#212121",
                }}
              >
                Frequently Asked Questions
              </Typography>
            </Box>
            <Box
              sx={{
                marginTop: ["2.5rem", "3.875rem"],
                paddingBottom: ["3.75rem", "7.5rem"],
              }}
            >
              {faqData.map((item, index) => (
                <Accordion
                  key={index}
                  expanded={expanded === item.panel}
                  onChange={handleChange(item.panel)}
                  sx={{ backgroundColor: "#EEF6FF" }}
                >
                  <AccordionSummary
                    expandIcon={
                      <ExpandMore
                        sx={{ color: `${theme.palette.primary.main}` }}
                      />
                    }
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        marginBottom: ["0.5rem", "2rem"],
                        fontSize: ["0.75rem", "1.25rem"],
                        fontWeight: 700,
                        letterSpacing: ["0.0079055rem", "0.01rem"],
                        color: "#212121",
                      }}
                    >
                      {item.question}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography
                      variant="h6"
                      sx={{
                        marginBottom: ["1.25rem", "2rem"],
                        fontSize: ["0.75rem", "1.25rem"],
                        fontWeight: 400,
                        letterSpacing: ["0.0079055rem", "0.01rem"],
                        color: "#212121",
                      }}
                    >
                      {item.answer}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              ))}
            </Box>
          </Container>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box>
            <Typography
              variant="h3"
              sx={{
                marginTop: ["3.75rem", "7.5rem"],
                fontSize: ["1.375rem", "3rem"],
                fontWeight: 700,
                color: "#212121",
                textAlign: "center",
              }}
            >
              Create a new account
            </Typography>
          </Box>
          <Box>
            <Typography
              variant="h6"
              sx={{
                marginTop: ["0.5rem", "2rem"],
                fontSize: ["0.75rem", "1.25rem"],
                fontWeight: 400,
                letterSpacing: ["0.0079055rem", "0.01rem"],
                color: "#212121",
                textAlign: "center",
              }}
            >
              Join thousands of educational institutions already using Youstad
            </Typography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            {isMobile ? (
              <StyledButton
                variant="contained"
                sx={{
                  height: "1.5rem",
                  width: "10.375rem",
                  marginTop: "1.25rem",
                  marginBottom: "3.75rem",
                  backgroundColor: theme.palette.primary.main,
                  borderRadius: "1.022175rem",
                }}
              >
                <Typography sx={{ fontSize: "0.5rem" }}>SIGN UP NOW</Typography>
              </StyledButton>
            ) : (
              <StyledButton
                variant="contained"
                sx={{
                  height: "3rem",
                  width: "11.6875rem",
                  marginTop: "3.75rem",
                  marginBottom: "7.5rem",
                  backgroundColor: theme.palette.primary.main,
                }}
              >
                SIGN UP NOW
              </StyledButton>
            )}
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default FAQs;
